export default __webpack_public_path__ + "static/media/ya-station.e917a686.png";